























import Vue from "vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetDistinctInstallationsCommand, GetDistinctInstallationsResData } from "@/model/communication/device/GetDistinctInstallationsCommand";

export default Vue.extend({
    data() {
        return {
            loading: true,
            availableInstallations: ["Installation-00", "Installation-01", "Installation-02", "IA300CC-00001"],
            selectedInstallation: null,
        };
    },
    props: ["widget"],
    computed: {
        comboboxInstallations() {
            return this.availableInstallations.map((item) => ({ text: item, value: item }));
        },

        widgetId() {
            return this.widget.id;
        },
    },
    watch: {
        selectedInstallation(newValue) {
            this.widget.filter.byInstallationName = [newValue ? newValue.text : null];
        },
        widgetId() {
            this.setPreselectedItem();
        },
    },
    methods: {
        async getDistinctInstallations() {
            try {
                let res = await new GetDistinctInstallationsCommand().execute();

                if (res.responseStatus == ApiResponseStatusEnum.Success) this.availableInstallations = (res as GetDistinctInstallationsResData).installationNames;
                else console.error("cannot fetch installation names");
                this.setPreselectedItem();
                this.loading = false;
            } catch (error) {
                console.error("Error fetching installation names error: ", error);
            }
            this.loading = false;
        },

        setPreselectedItem() {
            if (this.widget && this.widget.filter && Array.isArray(this.widget.filter.byInstallationName))
                if (Array.isArray(this.comboboxInstallations) && this.comboboxInstallations.filter((i) => i.text == this.widget.filter.byInstallationName[0]).length > 0)
                    this.selectedInstallation = this.comboboxInstallations.filter((i) => i.text == this.widget.filter.byInstallationName[0])[0];
        },
    },
    mounted() {
        this.getDistinctInstallations();
        if (this.widget && this.widget.filter && Array.isArray(this.widget.filter.byInstallationName))
            if (this.availableInstallations.filter((i) => i.name == this.widget.filter.byInstallationName[0]).length > 0)
                this.selectedInstallation = this.availableInstallations.map((item) => ({ text: item, value: item }))[0];
    },
});
